import handleResponse from './request/handleProfileResponse'

export default function(api: GlobalFetch) {
  return async function(calendarId: number) {
    const response = await api.fetch(
      `/api/v2/object/index/id_calendar/${calendarId}`,
    )

    return await handleResponse(response)
  }
}
